import { useState } from "react";
import { supabase, perfilService } from "../services/supabase";
import { C, Btn, Input } from "./ui";

export function LoginScreenEmail({ onLogin }) {
  const [step, setStep] = useState("login"); // "login" | "profile"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSignup, setIsSignup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // PASO 1: Login/Signup
  const handleAuth = async () => {
    if (!email || !password) {
      setError("Completá email y contraseña");
      return;
    }

    if (isSignup && password !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    if (isSignup && password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setLoading(true);
    setError("");

    try {
      if (isSignup) {
        const { data, error: err } = await supabase.auth.signUp({
          email,
          password,
        });
        if (err) throw err;
        // Si Supabase devolvió sesión activa (confirmación de email desactivada),
        // entrar directo; el candado de perfil pedirá los datos.
        if (data?.session) {
          onLogin(data.user);
        } else {
          // Email confirmation activada: avisar que revise su correo.
          setStep("checkEmail");
        }
      } else {
        const { data, error: err } = await supabase.auth.signInWithPassword({
          email,
          password,
        });
        if (err) throw err;
        onLogin(data.user);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${C.pasto} 0%, ${C.tierra} 100%)`,
      }}
    >
      <div
        style={{
          background: C.white,
          borderRadius: 16,
          padding: 32,
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            fontFamily: "serif",
            fontSize: 28,
            fontWeight: 600,
            color: C.tierra,
            marginBottom: 8,
            textAlign: "center",
          }}
        >
          Campo<span style={{ color: C.pasto, fontStyle: "italic" }}>IA</span>
        </div>
        <div
          style={{
            fontSize: 13,
            color: C.muted,
            marginBottom: 24,
            textAlign: "center",
          }}
        >
          Gestión de rodeo y campos
        </div>

        {step === "login" ? (
          <>
            <Input
              label="Email"
              value={email}
              onChange={setEmail}
              type="email"
              placeholder="tu@email.com"
            />
            <Input
              label="Contraseña"
              value={password}
              onChange={setPassword}
              type="password"
              placeholder="••••••••"
            />

            {isSignup && (
              <Input
                label="Confirmar contraseña"
                value={confirmPassword}
                onChange={setConfirmPassword}
                type="password"
                placeholder="••••••••"
              />
            )}

            {error && (
              <div
                style={{
                  background: "#FAE8E8",
                  color: C.danger,
                  padding: "10px 12px",
                  borderRadius: 8,
                  fontSize: 12,
                  marginBottom: 14,
                  textAlign: "center",
                }}
              >
                {error}
              </div>
            )}

            <Btn
              variant="primary"
              onClick={handleAuth}
              disabled={loading || !email || !password}
              style={{ width: "100%", marginBottom: 10 }}
            >
              {loading
                ? "Cargando..."
                : isSignup
                ? "Crear cuenta"
                : "Iniciar sesión"}
            </Btn>

            <button
              onClick={() => {
                setIsSignup(!isSignup);
                setError("");
                setConfirmPassword("");
              }}
              style={{
                width: "100%",
                background: "none",
                border: "none",
                color: C.pasto,
                cursor: "pointer",
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              {isSignup
                ? "¿Ya tienes cuenta? Inicia sesión"
                : "¿Nuevo? Crear cuenta"}
            </button>
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>📧</div>
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: C.tierra,
                marginBottom: 10,
              }}
            >
              ¡Revisá tu correo!
            </div>
            <div
              style={{
                fontSize: 13,
                color: C.muted,
                lineHeight: 1.6,
                marginBottom: 20,
              }}
            >
              Te enviamos un link de confirmación a<br />
              <strong style={{ color: C.tierra }}>{email}</strong>.<br />
              Hacé clic en el link y volvé acá para completar tus datos.
            </div>
            <button
              onClick={() => {
                setStep("login");
                setIsSignup(false);
                setError("");
              }}
              style={{
                width: "100%",
                background: "none",
                border: "none",
                color: C.pasto,
                cursor: "pointer",
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              ← Volver al inicio
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// Pantalla completa de perfil (candado): se muestra cuando el usuario
// está logueado pero todavía no completó sus datos (ej: confirmó email y
// entró directo salteando el paso de perfil).
export function ProfileGate({ email, onSave }) {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `linear-gradient(135deg, ${C.pasto} 0%, ${C.tierra} 100%)`,
      }}
    >
      <div
        style={{
          background: C.white,
          borderRadius: 16,
          padding: 32,
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            fontFamily: "serif",
            fontSize: 28,
            fontWeight: 600,
            color: C.tierra,
            marginBottom: 8,
            textAlign: "center",
          }}
        >
          Campo<span style={{ color: C.pasto, fontStyle: "italic" }}>IA</span>
        </div>
        <div
          style={{
            fontSize: 13,
            color: C.muted,
            marginBottom: 24,
            textAlign: "center",
          }}
        >
          ¡Bienvenido! Solo falta completar tus datos
        </div>
        <ProfileForm email={email} onSave={onSave} />
      </div>
    </div>
  );
}

// Formulario de datos del usuario
function ProfileForm({ email, onSave }) {
  const [phone, setPhone] = useState("+598");
  const [nombreCampo, setNombreCampo] = useState("");
  const [ubicacion, setUbicacion] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    if (!phone || phone.length < 10) {
      setError("Ingresá un celular válido");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await perfilService.crear({
        phone,
        nombre_campo: nombreCampo,
        ubicacion,
      });

      onSave({ phone, nombreCampo, ubicacion });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        style={{
          fontSize: 13,
          color: C.muted,
          marginBottom: 16,
          lineHeight: 1.5,
        }}
      >
        Completá tus datos para continuar:
      </div>

      <Input
        label="Celular (WhatsApp) *"
        value={phone}
        onChange={setPhone}
        type="tel"
        placeholder="+598 99 123 456"
      />

      <Input
        label="Nombre del campo"
        value={nombreCampo}
        onChange={setNombreCampo}
        placeholder="Ej: El Paraíso"
      />

      <Input
        label="Ubicación (Depto.)"
        value={ubicacion}
        onChange={setUbicacion}
        placeholder="Ej: Soriano"
      />

      {error && (
        <div
          style={{
            background: "#FAE8E8",
            color: C.danger,
            padding: "10px 12px",
            borderRadius: 8,
            fontSize: 12,
            marginBottom: 14,
            textAlign: "center",
          }}
        >
          {error}
        </div>
      )}

      <Btn
        variant="primary"
        onClick={handleSave}
        disabled={loading || !phone}
        style={{ width: "100%", marginBottom: 10 }}
      >
        {loading ? "Guardando..." : "Continuar"}
      </Btn>

      <div
        style={{
          fontSize: 11,
          color: C.muted,
          textAlign: "center",
        }}
      >
        * Los datos se usan solo para mejorar tu experiencia
      </div>
    </div>
  );
}

export function LogoutButton({ user, onLogout }) {
  return (
    <button
      onClick={async () => {
        await supabase.auth.signOut();
        onLogout();
      }}
      style={{
        background: "none",
        border: "none",
        color: C.arena,
        cursor: "pointer",
        fontSize: 12,
        fontFamily: "monospace",
      }}
    >
      {user?.email || "Usuario"} · Salir
    </button>
  );
}
